<template lang="html">

    <section class="filtro">

        <div class="container">

            <div class="top row-between">
                <p>Filtrar ofertas de prácticas por:</p>
            </div>
            <div class="middle row-between">
                <div class="search-list row-start ais" :full="showmore">
                    <div class="search-el">
                        <label for="">Palabra clave</label>
                        <input type="text" placeholder="Escribe para buscar"
                            v-model="filtro.palabraclave">
                    </div>
                    <div class="search-el">
                        <label for="">Provincia</label>
                        <select name="" id="" v-model="filtro.provincia">
                            <option value="">Selecciona una provincia</option>
                            <option v-for="data in values.provincia" :value="data">{{data}}</option>
                        </select>
                    </div>
                    <template v-if="showmore">
                        <div class="search-el">
                            <label for="">Sector de actividad</label>
                            <select name="" id="" v-model="filtro.sector">
                                <option value="">Selecciona un sector</option>
                                <option v-for="data in values.sector" :value="data">{{data}}</option>
                            </select>
                        </div>
                        <div class="search-el">
                            <label for="">Estudios</label>
                            <select name="" id="" v-model="filtro.estudios">
                                <option value="">Seleccionar estudios</option>
                                <option v-for="data in values.titulaciones" :value="data">{{data}}</option>
                            </select>
                        </div>
                        <div class="search-el -checks row-start -ofertas-type" v-if="isEstudiante">
                            <h3 class="fake-label">Mostrar solamente</h3>
                            <div class="contenedor-check">
                                <input type="checkbox" id="interna"
                                    v-model="filtro.practicasInternas">
                                <label for="interna">Prácticas Internas</label>
                            </div>
                            <div class="contenedor-check">
                                <input type="checkbox" id="externa"
                                    v-model="filtro.ofertasInternacionales">
                                <label for="externa">Ofertas Internacionales</label>
                            </div>
                            <div class="contenedor-check">
                                <input type="checkbox" id="programa-practicas"
                                    v-model="filtro.programaPracticas">
                                <label for="programa-practicas">Programas de
                                    prácticas</label>
                            </div>
                        </div>

                    </template>
                </div>
                <div class="contenedor-botones row-end">
                    <button class="btn">Buscar</button>
                </div>
            </div>

        </div>


    </section>


</template>

<script lang="js">

    import {mapGetters} from 'vuex';
    
    export default {
        name: 'filtro-ofertas',
        props : ['values'],
        mounted(){
            if(this.$route.params.filtro == "practicas-internas"){
                this.filtro.practicasInternas = true;
                this.$emit('input', this.filtro);
            }
        },
        data() {
            return {
                showmore: true,
                filtro : {
                    palabraclave : '',
                    provincia : '',
                    sector : '',
                    estudios : '',
                    practicasInternas : false,
                    ofertasInternacionales : false,
                    programaPracticas: false
                }
            }
        },
        computed : {
            ...mapGetters({
                dominios : 'getDominiosOrder',
                isEstudiante : 'isEstudiante'
            })
        },
        watch : {
            'filtro': {
                deep: true,
                handler(){
                    this.$emit('input', this.filtro);
                }
                }
            }
        }
    
</script>


// WEBPACK FOOTER //
// src/components/parts/filtro-ofertas.vue